import { conditionFormChecker, putField } from "../../../../utils/form";
import lodash from "lodash";
import {
    createFieldSelect, createFieldTemplateBuilder, createFieldTextArea
} from "../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../i18n";
import { Button, Form } from "ant-design-vue";

import store from "../../../../store";
import { CIcon } from "../../../account/verify-identity-file/attach-identity/attach-identity-id-card.logic";
import { defineAsyncComponent } from "vue";
import { onClickDelete } from "./choice.logic";

export const callChoiceType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "CHOICE_TYPE", value: searchQuery })

const ChoiceList = defineAsyncComponent(() => import("./ChoiceList"));

export const createField = ({ props, data, key, items, initItems, isLoading, record, index }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            ...createFieldQuestion({ props, data, key, items, initItems, isLoading, record, index }),
            ...createFieldChoice({ props, data, key, items, initItems, isLoading }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 2 }, wrapperCol: { xs: 24, md: 22 } }),
                label: () => `${i18n.global.t("model.surveyQuestion.remark")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.remark,
                            "onUpdate:value": (value) => (model.remark = value),
                            disabled: viewOnly,
                            autoSize: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
        ]
    });
};

export const createFieldQuestion = ({ props, data, key, record, index }) => {
    const { viewOnly, canDelete } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}title`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => `${i18n.global.t("model.surveyQuestion.title")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.title,
                            "onUpdate:value": (value) => (model.title = value),
                            disabled: viewOnly,
                            autoSize: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refChoiceType`,
                colProp: () => ({ xs: 24, md: 10  }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.surveyQuestion.refChoiceType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refChoiceType,
                            "onUpdate:value": value => {
                                model.refChoiceType = value;
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callChoiceType({searchQuery}) ,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            {
                visible: () => canDelete,
                // visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}deleteChoiceButton`,
                colProp: () => ({ xs: 24, md: 2 }),
                formItemProp: () => ({ wrapperCol: { xs: 24, md: 24 } }),
                label: () => "",
                formItemRender: ({ field }) => {
                    const label = field?.label?.();
                    const formItemProp = field?.formItemProp?.({ field });
                    return (
                        <Form.Item label={label} {...formItemProp}>
                            <Button
                                class="btn-danger m-2"
                                size="small"
                                onClick={() => onClickDelete({record, index, props, data})}
                            >
                                <CIcon file="delete.svg"></CIcon>
                            </Button>
                        </Form.Item>
                    );
                }
            }
        ]
    })
}

export const createFieldChoice = ({ props, data, key }) => {
    const { viewOnly, menuContext, canCreate } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                colProp: () => ({ xs: 24 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        {
                            visible: () => canCreate,
                            // visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}addChoiceButton`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 2 }, wrapperCol: { xs: 24, md: 22 } }),
                            label: () => i18n.global.t("model.questionChoices.addChoiceButton"),
                            formItemRender: ({ field }) => {
                                const label = field?.label?.();
                                const formItemProp = field?.formItemProp?.({ field });
                                return (
                                    <Form.Item label={label} {...formItemProp}>
                                        <Button
                                            size="small"
                                            class={"btn-success"}
                                            onClick={() => {
                                                model?.questionChoices?.push({})
                                            }}
                                        >
                                            <CIcon file="plus.svg"></CIcon>
                                        </Button>
                                    </Form.Item>
                                );
                            }
                        },
                        {
                            visible: () => true,
                            colProp: () => ({ xs: 24, class: "mt-3" }),
                            formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                            inputRender: () => {
                                const componentProp = lodash.merge(
                                    {
                                        menuContext: menuContext,
                                        viewOnly: viewOnly,
                                        visibleCardTitle: true,
                                        dataProp: data,
                                        itemsKey: `${prefix}questionChoices`,
                                        canCreate: !viewOnly,
                                        canDelete: !viewOnly,
                                        surveyQuestionKey : key
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "QuestionChoicesList" } })
                                );
                                return <ChoiceList {...componentProp}></ChoiceList>;
                            }
                        }
                    ]})
                })
            }),
        ]
    })
}